module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "75%"
    },
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Helion & Company Limited"), _c('br'), _vm._v("26 Willow Road"), _c('br'), _vm._v("Solihull"), _c('br'), _vm._v("West Midlands"), _c('br'), _vm._v("B91 1UE"), _c('br'), _vm._v("Tel. 0121 705 3393"), _c('br'), _vm._v("Fax 0121 711 4075"), _c('br'), _vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:info@helion.co.uk"
    }
  }, [_vm._v("info@helion.co.uk")]), _c('br'), _vm._v("Website: "), _c('a', {
    attrs: {
      "href": "http://www.helion.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.helion.co.uk")]), _c('br'), _vm._v("Twitter: "), _c('a', {
    attrs: {
      "href": "mailto:@helionbooks"
    }
  }, [_vm._v("@helionbooks")]), _c('br'), _vm._v("Visit our blog "), _c('a', {
    attrs: {
      "href": "http://blog.helion.co.uk/",
      "target": "_blank"
    }
  }, [_vm._v("http://blog.helion.co.uk/")])]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Published by Helion & Company 2014"), _c('br'), _vm._v("Designed and typeset by Bookcraft Limited, Stroud, Gloucestershire"), _c('br'), _vm._v("Cover designed by Euan Carter, Leicester ("), _c('a', {
    attrs: {
      "href": "http://www.euancarter.com",
      "target": "_blank"
    }
  }, [_vm._v("www.euancarter.com")]), _vm._v(")"), _c('br'), _vm._v("Printed by Gutenberg Press Limited, Tarxien, Malta")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Text © Ben Kite 2014"), _c('br'), _vm._v("Illustrations © as individually credited"), _c('br'), _vm._v("Maps by George Anderson © Helion & Company 2014")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("The author has made every reasonable effort to trace the copyright holders of material appearing in this publication, and to credit them accordingly. Any correspondence regarding this matter should be directed to Ben Kite, c/o the publishers, at the above address.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Front cover – Clifford Brown of the Somerset Light Infantry quenches his thirst after the capture of Mont Pinçon, 7 August. (Imperial War Museum B8787).")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("ISBN: 978 1 909982 55 0"), _c('br'), _vm._v("\nPAPERBACK ISBN: 978 1 911096 18 4"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 911096 90 0")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("British Library Cataloguing-in-Publication Data."), _c('br'), _vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form, or by any means, electronic, mechanical, photocopying, recording or otherwise, without the express written consent of Helion & Company Limited.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("For details of other military history titles published by Helion & Company Limited contact the above address, or visit our website: "), _c('a', {
    attrs: {
      "href": "http://www.helion.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("http://www.helion.co.uk")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("We always welcome receiving book proposals from prospective authors.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0